import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { InputDisplay } from '@shared/ui/inputs';
import { RangePickerPopupComponent } from '../range-picker-popup/range-picker-popup.component';
import { DateRangeTerm } from '../range-picker/range-picker.models';
import { SearchRangeTerms } from '../../models/search-range-terms.models';

@Component({
  selector: 'shared-ui-datetime-range-picker-popup-group',
  templateUrl: './range-picker-popup-group.component.html',
  styleUrls: ['./range-picker-popup-group.component.css'],
  standalone: false,
})
export class RangePickerPopupGroupComponent extends RangePickerPopupComponent implements OnInit {
  @ViewChild(RangePickerPopupComponent) rangePickerPopup?: RangePickerPopupComponent;
  @Input() display = InputDisplay.Block;
  @Input() name = '';

  constructor(cdr: ChangeDetectorRef) {
    super(cdr);
  }

  isInline(): boolean {
    return this.display === InputDisplay.Inline || this.isJustified();
  }

  isInlineOnly(): boolean {
    return this.display === InputDisplay.Inline;
  }

  isJustified(): boolean {
    return this.display === InputDisplay.InlineSpaced;
  }

  dateFilterChanged(dateRangeTerm: DateRangeTerm): void {
    this.dateFilter.emit(dateRangeTerm);
  }

  override reset(): void {
    this.rangePickerPopup?.reset();
  }

  setDisplayRange(startDate: Date, endDate: Date, term?: SearchRangeTerms): void {
    if (this.rangePickerPopup) {
      this.rangePickerPopup.selectedSearchRangeTerm = term;
      this.rangePickerPopup.rangePicker?.updateRange(startDate, endDate);
    }
  }
}
